import { Row, Col, Form } from "react-bootstrap"
import { useState } from "react"
// import { useParams } from "react-router-dom"
import { useCallback, useEffect } from "react"
import { useSelector } from 'react-redux';
import AddRole from "./roles/AddRole";
import RoleCard from './roles/RoleCard';


export default function RolesCard({ onCountChange }) {

  const url = process.env.REACT_APP_URL;
  // const meetingId = useParams().meetingId;
  const [roles, setRoles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const { user: authUser } = useSelector(x => x.auth);

  const getRoles = useCallback(async () => {
    try {
      const response = await fetch(`${url}/meetingRoles`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const data = await response.json();
      setRoles(data);
    } catch (e) {
      console.log(`Roles component - Get Roles error: ${e}`);
    }
  }, [url]);

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredRoles = roles.filter(role =>
    String(role?.name || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedRoles = [...filteredRoles].sort((a, b) =>
    String(a?.name || '').localeCompare(String(b?.name || ''))
  );

  useEffect(() => {
    if (typeof onCountChange === 'function') {
      onCountChange(sortedRoles.length);
    }
  }, [onCountChange, sortedRoles.length]);

  return (
    <div className='events-roles-admin-panel roles-admin-panel'>
      <div className='roles-admin-top'>
        <h5 className='mb-0'>Meeting Roles</h5>
      </div>

      <div className='events-roles-admin-controls'>
        <Row className='header mb-2'>
          {(authUser && authUser.user.acl === 'Officer') &&
            <Col xs={12} lg={12} key={'newRole'}>
              <AddRole getRoles={getRoles} />
            </Col>
          }
        </Row>
        <Row className='mb-3'>
          <Col xs={12} lg={12}>
            <div className='assignments-search-wrap'>
              <Form.Control
                type="text"
                placeholder="Search for a role..."
                value={searchTerm}
                onChange={handleSearchChange}
                data-bs-theme={'dark'}
                className='assignments-search-input'
              />
              {searchTerm && (
                <button
                  type='button'
                  className='assignments-search-clear'
                  onClick={() => setSearchTerm('')}
                  aria-label='Clear search'
                >
                  <i className='bi bi-x' />
                </button>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <div className='events-roles-admin-list'>
        <Row className='events-list m-0'>
          {sortedRoles.map(role => (
            <Col xs={12} lg={12} key={role._id} className='mb-2 px-0'>
              <RoleCard role={role} getRoles={getRoles} />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  )
}